module.exports = __webpack_public_path__ + "static/paris-012-0c5132b23df362acbbe331c6072f5069.jpg";